import {
	DEVICE_TABLET_PORTRAIT,
	DEVICE_TABLET_LANDSCAPE,
	DEVICE_MOBILE_PORTRAIT,
	DEVICE_MOBILE_LANDSCAPE,
} from '../constants/types';
import { isArray } from 'lodash';

export default function getCategoryName(categories, bestViewedOn) {
	let cat = '';
	let suffix = '';

	//console.log(bestViewedOn);
	switch (bestViewedOn) {
		case DEVICE_TABLET_PORTRAIT:
		case DEVICE_TABLET_LANDSCAPE:
			suffix += ' - tablet';
			break;
		case DEVICE_MOBILE_PORTRAIT:
		case DEVICE_MOBILE_LANDSCAPE:
			suffix += ' - mobile';
			break;
	}

	if (categories && isArray(categories) && categories.length) {
		cat = categories.slice(0, 1).map((item) => {
			return item.name + suffix;
		});
	} else if (categories && typeof categories === 'object') {
		if (categories.name) {
			cat = categories.name + suffix;
		}
	} else if (categories && typeof categories === 'string') {
		cat = categories + suffix;
	}

	return cat;
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/getCategoryName.js
 **/